import { motion } from "framer-motion";
import { Rocket } from "lucide-react";

const aboutText = "Who We Are at AdBlastX";

const AboutIntro = () => {
  return (
    <section className="relative py-20 text-center bg-gradient-to-br from-indigo-50 via-white to-pink-50 overflow-hidden">
      {/* Background shimmer */}
      <motion.div
        className="absolute top-1/2 left-1/2 w-[500px] h-[500px] bg-gradient-to-br from-indigo-200 to-pink-200 blur-3xl opacity-30 rounded-full -translate-x-1/2 -translate-y-1/2"
        animate={{ scale: [1, 1.05, 1], opacity: [0.2, 0.4, 0.2] }}
        transition={{ duration: 10, repeat: Infinity }}
      />

      {/* Heading */}
      <motion.h1
        className="text-4xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600"
        initial="hidden"
        whileInView="visible"
        transition={{ staggerChildren: 0.05 }}
        viewport={{ once: true }}
      >
        {aboutText.split("").map((char, idx) => (
          <motion.span
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            {char}
          </motion.span>
        ))}
      
      </motion.h1>

      <motion.p
        className="text-gray-600 mt-4 text-lg max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        At AdBlastX, we're a passionate team committed to transforming digital publishing through cutting-edge ad monetization and real-time analytics. Innovation and transparency are at the heart of everything we do.
      </motion.p>

      {/* Animated Rocket Icon */}
      <motion.div
        className="mt-10 inline-flex items-center justify-center bg-gradient-to-br from-pink-500 to-indigo-500 text-white p-4 rounded-full shadow-lg"
        animate={{ rotate: [0, 360] }}
        transition={{ duration: 6, ease: "linear", repeat: Infinity }}
        whileHover={{
          scale: 1.2,
          rotate: 0,
          y: -10,
          boxShadow: "0 0 20px rgba(236, 72, 153, 0.4)",
        }}
      >
        <Rocket className="w-8 h-8" />
      </motion.div>
    </section>
  );
};

export default AboutIntro;
